import React from "react"
import styles from "./contact.module.css"

export default ({ data }) => <div>{data && <form></form>}</div>
